<template>
  <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
       :class="message_type">
    <button type="button" class="close" aria-label="Close" @click="$emit('close')">
      <span aria-hidden="true">&times;</span>
    </button>
    <span v-html="message"></span>
  </div>
</template>


<script>

export default {

  props: {
    message: "",
    message_type: "",
  },


  mounted() {
  },


}

</script>
